const faq = document.querySelectorAll(".faq__title");

faq?.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.preventDefault();
    item.parentElement.querySelector("ul").classList.toggle("hidden");
    item.parentElement.querySelector(".faq__icon-plus").classList.toggle("hidden");
    item.parentElement.querySelector(".faq__icon-minus").classList.toggle("hidden");
  });
});

const faqQuestion = document.querySelectorAll(".faq__question");

faqQuestion?.forEach((item) => {
  item.addEventListener("click", (e) => {
    e.preventDefault();
    item.parentElement.querySelector(".faq__answer")?.classList.toggle("hidden");
  });
});

const faqSearch = document.getElementById("faq-search");

faqSearch?.addEventListener("input", (e) => {
  const searchKey = e.target.value.toLowerCase();

  for (const entry of faq) {
    const entries = entry.parentElement.querySelector("ul");
    entries?.classList.add("hidden");

    const includesKeyword = entries?.textContent.toLowerCase().includes(searchKey);

    if (searchKey && includesKeyword) {
      entries.classList.remove("hidden");
    }
  }
});
